import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Modal from 'components/common/modal'
import IconCircle from 'components/common/icon_circle'

import cssModules from 'react-css-modules'
import styles from './campaign_not_found.less'
import { getI18n } from 'client/i18n'

const i18n = getI18n('components/pages/campaign_not_found')

class CampaignNotFound extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
  }

  render() {
    return (
      <Modal animate={false} showClose={false}>
        <div styleName="campaign-not-found">
          <div styleName="icon-container">
            <IconCircle type="rocket" iconSize="big" strokeColor="blue" />
          </div>
          <div styleName="title">{i18n('title')}</div>
          <div styleName="description">{i18n('description')}</div>
          {/* TODO: link to marketing page */}
          <a
            data-pa-click="learnMore"
            href={`${GLOBAL_CONSTS.REQUEST_URI}/faq`}
            className="vx_btn vx_btn-block vx_btn-secondary"
            styleName="learn-button"
          >
            {i18n('learn')}
          </a>
        </div>
      </Modal>
    )
  }
}

export default connect()(cssModules(CampaignNotFound, styles))
